// The values of the contract with TIL that @nexxt/db builds its enums from (ADR-271): plain tuples, without zod, so the
// schema of the DB evaluates no schema of the messages. `til.ts` and `til-fields.ts` re-export and use them.

/** Systems a message goes to or comes from; `til` for the messages that stop at TIL (I-00). */
export const tilSystems = [
  "business_central",
  "til",
  "joor",
  "hubspot",
  "ims",
  "gxo",
  "document_service",
  "zendesk",
  "tlg_shipping",
  // F2: the tool that reads the lines of a supplier's packing list, not chosen yet (B-50, T-64, ADR-233)
  "doc_extraction",
] as const;
export type TilSystem = (typeof tilSystems)[number];

/** `platform.external_system`: the TIL systems plus the legacy ones (DM-05). */
export const externalSystems = [...tilSystems, "netsuite_legacy", "zedonk_legacy"] as const;

/**
 * What tells the outcome Nexxt owes for an `I-xx` from the message, wherever its type is stored (`platform.outbox`,
 * the inbox, `message_log`): `I-xx/outcome`.
 */
export const TIL_OUTCOME_SUFFIX = "/outcome";

/** Minutes TIL has to send the outcome of a message it accepted, unless the message has its own (contratto-til.md §7). */
export const TIL_OUTCOME_MINUTES = 15;

/** How an entity stands towards a system: never sent, its last state on its way, not there, or there. */
export const syncStatuses = ["not_synced", "sync_in_progress", "sync_failed", "sync_complete"] as const;
export type SyncStatus = (typeof syncStatuses)[number];

/** The documents of a shipment Nexxt asks Business Central for: the ones the warehouse ships the goods with. */
export const shipmentDocumentTypes = ["invoice", "proforma"] as const;

/**
 * Why the last state is not on the system. `not_ready`: the message could not be built, and the errors name what is
 * missing; the others are how its messages ended, the worst of them.
 */
export const syncFailures = ["not_ready", "message_dead", "failed", "rejected"] as const;
export type SyncFailure = (typeof syncFailures)[number];
